import colors from "../base/colors";
import typography from "../base/typography";

const { grey } = colors;
const { size } = typography;

const breadcrumbs = ({ items = [] }) => {
  return {
    styleOverrides: {
      li: {
        lineHeight: 0,
      },

      separator: {
        fontSize: size.sm,
        color: grey[600],
      },

      // Link styles
      "& a": {
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
          textDecoration: 'none',
          color: 'inherit'
        },
        '&:visited': {
          color: 'inherit'
        },
        '&:focus': {
          color: 'inherit'
        }
      }
    }
  }
};

export default breadcrumbs;
